import SellResult from "./SellResult";
export default SellResult;
